<div class="dashboard-container" *ngIf="!loading && metrics">

  <div class="dash-header">
    <h1 class="cyber-title">>_ {{ isGlobalMode ? 'SYSTEM OVERVIEW' : 'WORKSPACE OVERVIEW' }}</h1>
    <p class="subtitle">Estado de la infraestructura de IA y consumo de recursos.</p>
  </div>

  <!-- ============================================================
       FILA 1 — Widgets de salud del sistema (existentes)
       ============================================================ -->
  <div class="widgets-grid">
    <div class="widget-card">
      <div class="widget-icon" style="color: #a6e22e;">
        <svg viewBox="0 0 24 24" width="32" height="32"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
      </div>
      <div class="widget-data">
        <span class="widget-label">CONSUMO DE TOKENS (API)</span>
        <span class="widget-value">{{ metrics.tokens.consumed | number }} <span style="font-size:14px;color:#888;">/ {{ metrics.tokens.total | number }}</span></span>
        <div class="progress-bar-bg" style="margin-top: 10px; background: rgba(255,255,255,0.1); height: 6px; border-radius: 3px;">
          <div class="progress-bar-fill" [style.width.%]="tokenPercentage" [style.background]="tokenPercentage > 90 ? '#ff5f56' : (tokenPercentage > 70 ? '#ffbd2e' : '#a6e22e')" style="height: 100%; border-radius: 3px;"></div>
        </div>
      </div>
    </div>

    <div class="widget-card">
      <div class="widget-icon" style="color: #66d9ef;">
        <svg viewBox="0 0 24 24" width="32" height="32"><path fill="currentColor" d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"/></svg>
      </div>
      <div class="widget-data">
        <span class="widget-label">PROYECTOS EN MOTOR RAG</span>
        <span class="widget-value">{{ metrics.ragProjects }} <span style="font-size:14px;color:#888;">indexados</span></span>
      </div>
    </div>

    <div class="widget-card">
      <div class="widget-icon" style="color: #fd971f;">
        <svg viewBox="0 0 24 24" width="32" height="32"><path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
      </div>
      <div class="widget-data">
        <span class="widget-label">{{ isGlobalMode ? 'TENANTS / USUARIOS PENDIENTES' : 'USUARIOS ACTIVOS' }}</span>
        <span class="widget-value" *ngIf="isGlobalMode">{{ metrics.tenants }} <span style="font-size:14px;color:#888;"> / {{ metrics.pendingUsers }} req.</span></span>
        <span class="widget-value" *ngIf="!isGlobalMode">{{ metrics.activeUsers }} <span style="font-size:14px;color:#888;">miembros</span></span>
      </div>
    </div>
  </div>

  <!-- ============================================================
       FILA 2 — Actividad del mes (NUEVA)
       ============================================================ -->
  <ng-container *ngIf="monthly">
    <div class="section-header">
      <h3 class="section-title">>_ ACTIVIDAD DEL MES</h3>
    </div>

    <div class="kpi-row">
      <app-metric-card
          title="Estimaciones del mes"
          [value]="estimationsCurrent"
          [subtitle]="buildDeltaSubtitle(estimationsDeltaLabel)"
          [semantic]="estimationsSemantic"
          tooltipText="Total de estimaciones creadas desde el día 1 del mes en curso. Se compara con el mismo período del mes anterior."
          size="md">
      </app-metric-card>

      <app-metric-card
          title="Usuarios activos del mes"
          [value]="activeUsersCurrent"
          [subtitle]="buildDeltaSubtitle(activeUsersDeltaLabel)"
          [semantic]="activeUsersSemantic"
          tooltipText="Usuarios distintos que han iniciado sesión al menos una vez en el mes en curso."
          size="md">
      </app-metric-card>

      <app-metric-card
          title="Logins del mes"
          [value]="loginsCurrent"
          [subtitle]="buildDeltaSubtitle(loginsDeltaLabel)"
          [semantic]="loginsSemantic"
          tooltipText="Total de inicios de sesión registrados en el mes en curso."
          size="md">
      </app-metric-card>
    </div>

    <!-- ============================================================
         FILA 3 — Calidad y eficiencia del mes (NUEVA)
         ============================================================ -->
    <div class="section-header">
      <h3 class="section-title">>_ CALIDAD Y EFICIENCIA DEL MES</h3>
    </div>

    <div class="kpi-row">
      <app-metric-card
          title="MMRE del mes"
          [value]="mmreCurrent"
          [subtitle]="buildDeltaSubtitle(mmreDeltaLabel)"
          [semantic]="mmreSemantic"
          tooltipText="Error medio relativo (MMRE) calculado sobre tareas con ejecución registrada en el mes. Menor es mejor."
          size="md">
      </app-metric-card>

      <app-metric-card
          title="Tokens medios por estimación"
          [value]="avgTokensCurrent"
          [subtitle]="buildDeltaSubtitle(avgTokensDeltaLabel)"
          [semantic]="avgTokensSemantic"
          tooltipText="Tokens consumidos en promedio por estimación generada en el mes en curso. Menor indica más eficiencia del prompt."
          size="md">
      </app-metric-card>

      <app-metric-card
          title="Estimaciones por usuario activo"
          [value]="estPerUserCurrent"
          [subtitle]="buildDeltaSubtitle(estPerUserDeltaLabel)"
          [semantic]="estPerUserSemantic"
          tooltipText="Número medio de estimaciones que ha generado cada usuario activo en el mes en curso."
          size="md">
      </app-metric-card>
    </div>
  </ng-container>

  <!-- ============================================================
       BLOQUE INFERIOR — Accesos rápidos / actividad reciente (existente)
       ============================================================ -->
  <div class="dash-body">

    <div class="surface" *ngIf="isGlobalMode" style="flex:1;">
      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom: 20px;">
        <h3 class="cyber-title" style="font-size:14px; margin:0;">>_ ACCESOS DIRECTOS DE ADMINISTRACIÓN</h3>
      </div>
      <div style="display:flex; gap:15px;">
        <button class="btn primary" routerLink="/app/users">GESTIONAR USUARIOS</button>
        <button class="btn secondary" routerLink="/app/master-management">MAESTROS GLOBALES</button>
      </div>
    </div>

    <div class="surface" *ngIf="!isGlobalMode" style="flex:1;">
      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom: 20px;">
        <h3 class="cyber-title" style="font-size:14px; margin:0;">>_ ACTIVIDAD RECIENTE (ÚLTIMOS 5)</h3>
        <button class="btn primary btn-glow" routerLink="/app/proyectos">IR A PROYECTOS</button>
      </div>
      <table class="cyber-table">
        <thead>
          <tr>
            <th>PROYECTO</th>
            <th>FECHA CREACIÓN</th>
            <th>ESTADO</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of metrics.recentProjects">
            <td><strong style="color:var(--dl-color-theme-primary1);">{{ p.name }}</strong></td>
            <td>{{ p.creationdate | date:'short' }}</td>
            <td><span class="badge-status">{{ p.status || 'ACTIVO' }}</span></td>
          </tr>
          <tr *ngIf="!metrics.recentProjects || metrics.recentProjects.length === 0">
            <td colspan="3" style="text-align: center; color: #666; padding: 20px;">>_ No hay proyectos recientes.</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
